import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TokenListIssuerCell } from './token-list-issuer.cell';
import { TokenListIssuerHeader } from './token-list-issuer.header';

export const TokenListIssuerColumn: IdentifiedColumnDef<
  GatewayTokenModel,
  GatewayTokenModel['issuer']
> = {
  enableSorting: false,
  header: TokenListIssuerHeader,
  cell: TokenListIssuerCell,
};
